var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "building-detail-container" }, [
    _c("div", [
      _c(
        "a",
        {
          staticClass: "nav-back",
          on: {
            click: function ($event) {
              return _vm.$router.go(-1)
            },
          },
        },
        [_vm._v("\n      " + _vm._s(_vm.$t("back")) + "\n    ")]
      ),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "header" }, [
      _c("label", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("settings.tab.buildingDetail"))),
      ]),
      _vm._v(" "),
      _vm.aclHelper.getSettingsUpdateAccess()
        ? _c("div", { staticClass: "row controls" }, [
            _vm.editView && !_vm.isCreatingBuilding
              ? _c(
                  "button",
                  {
                    directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                    staticClass: "btn btn--darkblue",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.discardChange()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("action.cancel")) +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.editView
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn--orange",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.toEditMode()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("action.edit")) + "\n      "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.editView
              ? _c(
                  "button",
                  {
                    directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                    staticClass: "btn btn--orange",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.save()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("action.save")) + "\n      "
                    ),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "main" }, [
      _c(
        "div",
        { staticClass: "tabs" },
        _vm._l(_vm.itemHeaders, function (header) {
          return _c(
            "label",
            {
              key: header.id,
              class: { active: header.id === _vm.buildingId },
              on: {
                click: function ($event) {
                  return _vm.navToDetail(header.id)
                },
              },
            },
            [_vm._v("\n        " + _vm._s(header.name) + "\n      ")]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "profile-content-container" }, [
      _c(
        "div",
        { staticClass: "building-label clearfix u-sec-margin-bottom" },
        [
          _c(
            "label",
            {
              staticClass: "emphasis",
              class: { "required-flag": _vm.editView },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("settings.building.buildingName")) +
                  ":\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c("label", [
            _vm._v(_vm._s(_vm.buildingDetail.code || _vm.$t("emptyValue"))),
          ]),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "emphasis",
              class: { "required-flag": _vm.editView },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("settings.building.buildingDesc")) +
                  ":\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _vm.editView
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.buildingDetail.fullName,
                    expression: "buildingDetail.fullName",
                  },
                  { name: "hkldinput", rawName: "v-hkldinput" },
                ],
                staticClass: "building-detail-container-input",
                attrs: {
                  id: "modules-settings-building-detail-fullname",
                  type: "text",
                },
                domProps: { value: _vm.buildingDetail.fullName },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.buildingDetail,
                      "fullName",
                      $event.target.value
                    )
                  },
                },
              })
            : _c("label", [
                _vm._v(
                  _vm._s(_vm.buildingDetail.fullName || _vm.$t("emptyValue"))
                ),
              ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("div", [
            _c(
              "label",
              {
                staticClass: "emphasis",
                class: { "required-flag": _vm.editView },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("settings.building.zones")) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.editView
              ? _c(
                  "div",
                  [
                    _vm._l(_vm.zones, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "building-zones" },
                        [
                          _c("InputField", {
                            staticClass: "small-2 mediu-2 large2",
                            attrs: {
                              showFlag: false,
                              showColon: false,
                              value: item,
                              extendClass: "zone-input",
                            },
                            on: {
                              updateValue: function (val) {
                                return _vm.updateZone(val, index)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.editView
                            ? _c(
                                "div",
                                {
                                  staticClass: "list__item--delete",
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteZone(index)
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "fa fa-times fa-lg" })]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "i",
                      {
                        staticClass: "building-info__contacts--add",
                        on: {
                          click: function ($event) {
                            return _vm.addZones()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("settings.building.addNewZone")) +
                            " +\n          "
                        ),
                      ]
                    ),
                  ],
                  2
                )
              : _c("label", [
                  _vm._v(_vm._s(_vm.buildingZones || _vm.$t("emptyValue"))),
                ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "label",
              {
                staticClass: "emphasis",
                class: { "required-flag": _vm.editView },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("settings.building.floors")) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.editView
              ? _c("div", { staticClass: "floors-input-box" }, [
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.finalFloorsList.join(", ") || _vm.$t("emptyValue")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm.editView
                    ? _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.inputFloorsString,
                            expression: "inputFloorsString",
                          },
                          { name: "autosize", rawName: "v-autosize" },
                          { name: "hkldinput", rawName: "v-hkldinput" },
                        ],
                        attrs: {
                          id: "modules-settings-building-detail-floors",
                          placeholder:
                            _vm.$t("abbrivations.example") +
                            " 01F~12F, MF, 14F~100F",
                        },
                        domProps: { value: _vm.inputFloorsString },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.inputFloorsString = $event.target.value
                            },
                            function ($event) {
                              return _vm.onInputFloors()
                            },
                          ],
                        },
                      })
                    : _vm._e(),
                ])
              : _c("label", [
                  _vm._v(_vm._s(_vm.floorsList || _vm.$t("emptyValue"))),
                ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("label", { staticClass: "emphasis" }, [
              _vm._v(_vm._s(_vm.$t("settings.building.commonFloors"))),
            ]),
            _vm._v(" "),
            _vm.editView
              ? _c(
                  "div",
                  { staticClass: "common-floor-box" },
                  [
                    _c("HKLMultiSelect", {
                      staticClass: "multi-value",
                      attrs: {
                        options: _vm.finalFloorsList,
                        value: _vm.sortedSelectedCommonFloors,
                        showSearch: true,
                        placeholder: "",
                      },
                      on: {
                        change: function (val) {
                          _vm.selectedCommonFloors = val
                        },
                      },
                    }),
                  ],
                  1
                )
              : _c("label", [
                  _vm._v(_vm._s(_vm.commonFloorsStr || _vm.$t("emptyValue"))),
                ]),
          ]),
          _vm._v(" "),
          _vm.enableTenantProjectsFeature
            ? _c("label", { staticClass: "emphasis" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("settings.building.handoverTpl")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.enableTenantProjectsFeature
            ? _c("div", { staticClass: "template-list" }, [
                _c("table", [
                  _c("thead", [
                    _c("tr", [
                      _c("th", { staticClass: "template-name" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("settings.template.templateName")) +
                            "\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "template-updated-by" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("handover.lastUpdateOnandBy")) +
                            "\n              "
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    { staticClass: "handover-template-table" },
                    _vm._l(_vm.templateList, function (temp, index) {
                      return _c("tr", { key: index }, [
                        _c(
                          "td",
                          {
                            staticClass: "template-name",
                            on: {
                              click: function ($event) {
                                return _vm.gotoEditTemplatePage(temp.id)
                              },
                            },
                          },
                          [_c("a", [_vm._v(_vm._s(temp.title))])]
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "template-updated-by" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                temp.updator.displayName +
                                  " " +
                                  _vm.formatDate(temp.updatedAt)
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.templateList.length > 1 && _vm.isDeleteBtnShow
                            ? _c("i", {
                                staticClass: "operate fa-times fa",
                                on: {
                                  click: function ($event) {
                                    return _vm.openModal(temp, index)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]),
                      ])
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--darkblue",
                    attrs: { type: "button", disabled: _vm.isCreatingBuilding },
                    on: {
                      click: function ($event) {
                        return _vm.gotoEditTemplatePage()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("settings.building.addTemplate")) +
                        " +\n        "
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.enableGreenOperationFeature
            ? [
                _c("hr"),
                _vm._v(" "),
                _c("BuildingComfyInstallation", {
                  model: {
                    value: _vm.buildingDetail.comfyInstallation,
                    callback: function ($$v) {
                      _vm.$set(_vm.buildingDetail, "comfyInstallation", $$v)
                    },
                    expression: "buildingDetail.comfyInstallation",
                  },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "Modal",
            {
              ref: "confirm-delete-template-modal",
              staticClass: "confirm-delete-template-modal",
              attrs: { modalId: "delete-template-" + +new Date() },
            },
            [
              _c(
                "p",
                {
                  staticClass: "font-bold",
                  attrs: { slot: "modal-header" },
                  slot: "modal-header",
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("settings.template.deleteHint")) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
                _c(
                  "button",
                  { staticClass: "btn--orange", on: { click: _vm.closeModal } },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("action.cancel")) +
                        "\n          "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn--darkblue",
                    on: { click: _vm.delOneTemplate },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("action.ok")) +
                        "\n          "
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "float-right building-user" }, [
        _c(
          "div",
          _vm._l(_vm.buildingDetail.buildings, function (building, index) {
            return _c("label", { key: index }, [
              _c(
                "span",
                {
                  staticClass: "building_name--link",
                  on: {
                    click: function ($event) {
                      return _vm.navTo(
                        "building-handover-templates",
                        building.id
                      )
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(building.code) + ": " + _vm._s(building.fullName)
                  ),
                ]
              ),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "users" }, [
          _c("table", [
            _c("thead", [
              _c("tr", [
                _c("th", [_vm._v(_vm._s(_vm.$t("settings.buildingUser")))]),
                _vm._v(" "),
                _c("th", [_vm._v(_vm._s(_vm.$t("status.name")))]),
                _vm._v(" "),
                _c("th", [_vm._v(_vm._s(_vm.$t("lastLogin")))]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _c("tr", [
                  _c("td", [
                    _vm.items.length > 0
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterUser,
                              expression: "filterUser",
                            },
                          ],
                          staticClass: "table-input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.filterUser },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.filterUser = $event.target.value
                            },
                          },
                        })
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "settings-filter" },
                    [
                      _c("HKLSelect", {
                        staticClass: "table-multiselect align-center",
                        attrs: {
                          value: _vm.filterStatus,
                          "settings-filter-row": "",
                          options: _vm.statusHklOptions,
                          showSearch: false,
                          placeholder: "",
                        },
                        on: {
                          change: function (val) {
                            _vm.filterStatus = val
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("td"),
                ]),
                _vm._v(" "),
                _vm._l(_vm.orderedItems, function (item, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [
                      _c("span", [_vm._v(_vm._s(_vm.userName(item)))]),
                      _vm._v(" "),
                      !item.enabled
                        ? _c("i", {
                            staticClass: "fa fa-ban",
                            attrs: { "aria-hidden": "true" },
                          })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("customStatusLabel")(_vm.showStatus(item))
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("span", [_vm._v(_vm._s(_vm.lastLoginAt(item)))]),
                    ]),
                  ])
                }),
              ],
              2
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }